import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class TextDecreaseButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.fontSizeDecreaseButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<g>
						<path d="M7.3,23.6L4.6,32H1l9.1-26.7h4.2L23.3,32h-3.7l-2.9-8.4H7.3z M16.1,20.9l-2.6-7.7c-0.6-1.7-1-3.3-1.4-4.9H12 c-0.4,1.6-0.8,3.2-1.3,4.8L8,20.9H16.1z" />
					</g>
					<rect x="20" y="5" width="11" height="3" />
				</svg>
			</i>
		</Button>;
	}
}
